// extracted by mini-css-extract-plugin
export default {"controls":"MediaModal_controls__i6r0C","close":"MediaModal_close__Tof9l","arrow":"MediaModal_arrow__4M6fb"};